// import "foundation-sites/dist/css/foundation.min.css"

import $ from "jquery"
import whatInput from "what-input"
import "@hotwired/turbo-rails"
import TC from "@rolemodel/turbo-confirm"

// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

import "~/controllers/index"

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

window.$ = $
window.jQuery = $

import "foundation-sites"

// Initialize Foundation JS plugins
$(document).on("turbo:load", () => {
    $(document).foundation()
})

TC.start()